module.exports = __webpack_public_path__ + "1f5fb4f.woff2";